import { render, staticRenderFns } from "./remoteTask.vue?vue&type=template&id=75664656"
import script from "./remoteTask.vue?vue&type=script&lang=js"
export * from "./remoteTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports